<template>
    <v-app>
        <v-toolbar app class="app-toolbar emergency">
            <v-btn :ripple="false" icon @click="$router.go(-1)">
                <v-icon class="icon-light">arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title>Emergency</v-toolbar-title>
        </v-toolbar>
        <v-content pt-0>
            <v-container id="document-content" style="height: 100%; width: 100%" pt-0 pb-0 pr-0 pl-0 mt-0 mb-0 ml-0 mr-0>
                <v-layout row style="height: 100%; width: 100vw" pt-0>
                    <GmapMap
                            ref="map"
                            :center="{lat:-30.559482, lng:22.937506}"
                            :zoom="5"
                            style="width: 100vw; height: 100%">
                    </GmapMap>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>
<script>
    export default {
        data() {
            return {
                map: null,
                infoWindow: null,
                markers: []
            }
        },
        mounted() {
            var self = this;

            this.$refs.map.$mapPromise.then((map) => {
                self.map = map;

                map.addListener('dragend', function () {
                    self.getPlaces(map.getCenter().lat(), map.getCenter().lng(), map)
                });

                this.infoWindow = new google.maps.InfoWindow();

                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (response) {
                            map.panTo(new google.maps.LatLng(response.coords.latitude, response.coords.longitude));
                            map.setZoom(12);

                            self.getPlaces(response.coords.latitude, response.coords.longitude, map);
                        }, function (error) {
                            self.getPlaces(-30.559482, 22.937506, map);
                        }, {}
                    );
                } else {
                    self.getPlaces(-30.559482, 22.937506, map);
                }
            });
        },
        methods: {
            getPlaces(latitude, longitude, map) {
                var self = this;

                var latLong = new google.maps.LatLng(latitude, longitude);

                var service = new google.maps.places.PlacesService(map);
                service.nearbySearch({
                    location: latLong,
                    radius: 50000,
                    type: [self.$route.params.type]
                }, self.foundStoresCallback);
            },
            foundStoresCallback(results, status) {
                console.log(this.markers);

                for (var i in this.markers) {
                    this.markers[i].setMap(null);
                }

                self.markers = [];

                if (status === google.maps.places.PlacesServiceStatus.OK) {
                    for (var i = 0; i < results.length; i++) {
                        this.createMarker(results[i], this.infoWindow);
                    }
                }
            },
            createMarker(place, infoWindow) {
                var self = this;

                var placeLoc = place.geometry.location;

                var marker = new google.maps.Marker({
                    map: this.map,
                    position: place.geometry.location
                });

                google.maps.event.addListener(marker, 'click', function () {
                    infoWindow.setContent(place.name);
                    infoWindow.open(Map, this);
                });

                this.markers.push(marker);
            }

        }
    }


</script>